import React from 'react';
import ReactDOM from 'react-dom/client';
import './all.min.css';
import './style.css';
import App from './App.js';
import { BrowserRouter as Router} from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext.js';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <LanguageProvider>
  <Router>
  <App/>
  </Router>
  </LanguageProvider>
 
  
  
 
  </>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

